import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ClientDashboard from '../ClientDashboard';

export default function ClientRoutes() {

  return (
    <Routes>
      <Route exact path={'/'} element={<ClientDashboard />} />
    </Routes>
  );
}
